import { getToken } from './tokenStore';

const isDevelopment = process.env.NODE_ENV === 'development';
const AUTH_BASE = isDevelopment ? 'http://localhost:8085' : '/api/auth';

export interface APIKey {
  id: string;
  name: string;
  prefix: string;
  expires_at: string | null;
  last_used_at: string | null;
  created_at: string;
}

export interface CreateAPIKeyResponse extends APIKey {
  key: string; // raw key shown once
}

async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken();
  return fetch(AUTH_BASE + path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init.headers,
    },
    ...init,
  });
}

export async function listAPIKeys(): Promise<APIKey[]> {
  const res = await authFetch('/api-keys');
  if (!res.ok) throw new Error(`Failed to list API keys (${res.status})`);
  return res.json();
}

export async function createAPIKey(name: string, expiresAt?: string): Promise<CreateAPIKeyResponse> {
  const res = await authFetch('/api-keys', {
    method: 'POST',
    body: JSON.stringify({ name, expires_at: expiresAt }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({})) as Record<string, string>;
    throw new Error(err.error ?? `Failed to create API key (${res.status})`);
  }
  return res.json();
}

export async function revokeAPIKey(id: string): Promise<void> {
  const res = await authFetch(`/api-keys/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`Failed to revoke API key (${res.status})`);
}
